import React, { Component } from "react";
import PdfIcon from '../../../../../../src/img/pdf-icon.png';
import MsgIcon from "../../../../../../src/img/msg-icon2.png";
import XlsIcon from "../../../../../../src/img/exportExcel.png";
import FileIcon from "../../../../../../src/img/icn_export.png";
import DocIcon from "../../../../../../src/img/docx-icon.png";
import Translation from "../../../common/translation/translation.component";
import Icon from "../../../icon";
import { Table } from "react-bootstrap";
import moment from "moment";

export class OrderRequestFiles extends Component {

    setIcon = (filename, i) => {
        var getExtension = (filename.substr(filename.length - 4).toLowerCase()).toString();
        var icon;

        switch (getExtension) {
            case ".pdf":
                icon = PdfIcon;
                break;
            case ".msg":
                icon = MsgIcon;
                break;
            case "docx":
                icon = DocIcon;
                break;
            case ".xls":
            case "xlsx":
                icon = XlsIcon;
                break;
            default:
                icon = FileIcon;
        };
        let fileString = Array.isArray(this.props.files) ? this.props.files[i] : this.props.files;
        fileString = typeof fileString === "string" ? fileString : "";
        const parts = fileString.split('-');
        const datePart = parts.slice(-3).join('-');
        let newFile =  parts.slice(0, -3).join('-');
        let modifiedFilename = `${newFile}${datePart}`
        return (
            <div className="file-uploaded" key={i}>
                <Icon
                    name="paper-clip-light"
                    size="15px"
                    customClassName="file-icon-clip icon-right"
                />
                {/* <img src={icon} alt={icon} className="file-icon" /> */}
                <div className="file-name-cont"
                    data-toggle="tooltip"
                    title={filename}>
                    <div className="btn-tooltiptext">
                        <span className="file-name">
                            {filename}
                        </span>    
                        <span className="tooltip-text">{modifiedFilename}</span>
                    </div> 
                </div>
            </div>
        )
    }

    render() {
        const { files } = this.props;

       
        const truncateFileName = (name) => {
            const maxLength = 15;
            const truncatedLength = 7;
            const extIndex = name.lastIndexOf('.');
            let baseName = name.substring(0, extIndex);
            const extension = name.substring(extIndex);
            const parts = baseName.split('-');
            if (parts.length > 1) {
                const datePart = parts.slice(-3).join('-');
                baseName = parts.slice(0, -3).join('-');

                if (baseName.length > maxLength - datePart.length - 3) {
                    const truncatedBaseName = baseName.substring(0, truncatedLength) + '...';
                    return `${truncatedBaseName}${datePart}${extension}`;
                } else {
                    return `${baseName}${datePart}${extension}`;
                }
            } else {
                if (baseName.length > maxLength) {
                    const truncatedBaseName = baseName.substring(0, maxLength - extension.length - 3) + '...';
                    return `${truncatedBaseName}${extension}`;
                } else {
                    return `${baseName}${extension}`;
                }
            }
        }

        const truncatedFileNames = files ? files.map(truncateFileName) : null;

        return (
            <div>
                <Table>
                    <tbody>
                        <tr>
                            <td>
                                <h5 className="order-detail-location-title order-file-upload-adjustment"> <Translation translationKey="files_uploaded" /> </h5>
                            </td>
                            <td>
                                <div className="order-details-files-upload-container">
                                    {truncatedFileNames !== null && truncatedFileNames.length > 0?
                                        truncatedFileNames.map((file, i) => {
                                        return (
                                            this.setIcon(file, i)
                                        )
                                    }) :
                                    <div className="no-file"> <Translation translationKey="no_files_uploaded" /> </div>
                                }
                                </div>
                            </td>
                        </tr>
                    </tbody>
               
                </Table>
            </div>
        )
    }
}